module.exports = __webpack_public_path__ + "media/images/emoticons/note-7706caf56af905358c413f4798f7de8a.gif";